import { IntentInstallOptions } from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../../../../types/platformApi';
import { IntentInstallErrorCode, createIntentInstallError } from '../errors';
import { InstallationStrategy } from './types';

export class ApplicationsInstaller {
  private installationStrategy?: InstallationStrategy;

  constructor(strategy?: InstallationStrategy) {
    this.installationStrategy = strategy;
  }

  public setInstallationStrategy(strategy: InstallationStrategy) {
    this.installationStrategy = strategy;
    return this;
  }

  public install<T extends object = {}>(
    context: PlatformContext,
    apps: string[],
    options: IntentInstallOptions,
    strategyOptions?: T,
  ) {
    if (!this.installationStrategy) {
      throw createIntentInstallError(
        IntentInstallErrorCode.NoInstallationStrategyProvided,
      );
    }

    return this.installationStrategy.install(
      context,
      apps,
      options,
      strategyOptions,
    );
  }
}
